/* Public-page link policy for tools, blog articles, and CMS pages. */
(function () {
    'use strict';

    var getLinks = function(root) {
        return root instanceof HTMLAnchorElement
            ? [root]
            : Array.prototype.slice.call(root.querySelectorAll ? root.querySelectorAll('a[href]') : []);
    };

    var isExternal = function(link) {
        try {
            var destination = new URL(link.href, window.location.href);
            return /^https?:$/.test(destination.protocol) && destination.origin !== window.location.origin;
        } catch(error) {
            return false;
        }
    };

    var normalizeLink = function(link) {
        var relation = new Set((link.getAttribute('rel') || '').split(/\s+/).map(function(value) {
            return value.toLowerCase();
        }).filter(function(value) {
            return value && value !== 'noreferrer';
        }));

        if(isExternal(link)) relation.add('noopener');

        var normalizedRelation = Array.from(relation).join(' ');
        if(link.getAttribute('rel') !== normalizedRelation) link.setAttribute('rel', normalizedRelation);
    };

    var applyPolicy = function(root) {
        getLinks(root).forEach(normalizeLink);
    };

    applyPolicy(document);
    new MutationObserver(function(records) {
        records.forEach(function(record) {
            if(record.type === 'attributes') applyPolicy(record.target);
            record.addedNodes.forEach(function(node) {
                if(node.nodeType === Node.ELEMENT_NODE) applyPolicy(node);
            });
        });
    }).observe(document.body, {childList: true, subtree: true, attributes: true, attributeFilter: ['href', 'rel']});
}());
